import React from 'react';
import Link from 'next/link';
import { Sparkles } from 'lucide-react';

export default function LandingHero() {
  return (
    <section className="relative overflow-hidden hero-pattern bg-background">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28">
        <div className="flex justify-center">
          <div className="max-w-xl text-center">
            <div className="inline-flex items-center gap-2 bg-secondary rounded-full px-4 py-2 mb-6">
              <Sparkles size={14} className="text-primary" />
              <span className="text-sm font-600 text-foreground font-semibold">Hyperlocal offers, near you</span>
            </div>

            <h1 className="text-hero-xl text-foreground mb-5">
              Discover the{' '}
              <span className="gradient-brand-text">best local deals</span>
              {' '}in your neighborhood
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              OFY connects you with exclusive offers from businesses around you.
              Save more, support local, discover daily.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10 justify-center">
              <Link href="/customer-sign-up-login" className="btn-primary text-base px-6 py-3.5">
                User
              </Link>
              <Link href="/business-sign-up-login" className="btn-outline text-base px-6 py-3.5">
                Business
              </Link>
            </div>

            <div className="flex items-center gap-6 justify-center">
              <div className="text-center">
                <p className="text-2xl font-800 font-extrabold text-foreground">Local</p>
                <p className="text-sm text-muted-foreground">Businesses</p>
              </div>
              <div className="w-px h-10 bg-border" />
              <div className="text-center">
                <p className="text-2xl font-800 font-extrabold text-foreground">Fresh</p>
                <p className="text-sm text-muted-foreground">Daily Offers</p>
              </div>
              <div className="w-px h-10 bg-border" />
              <div className="text-center">
                <p className="text-2xl font-800 font-extrabold text-foreground">Near</p>
                <p className="text-sm text-muted-foreground">Your Pin Code</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}